const LANDING_PAGE_EVENTS = {
  RAILS_FC_STRIP:'rails_landing_fcstrip',
  RAILS_FC_STRIP_SHOWN:'rails_landing_fcstrip_shown',
  RAILS_FC_TG_V1:'rails_FC_TG_V1',
  RAILS_RAIL_MADAD_CLICKED: 'rails_ris_rail_madad_clicked',
};

const LISTING_PAGE_EVENTS = {
  MMT_RAIL_RN_LISTING: 'mob_rail_listing',
  MMT_RAIL_RN_LISTING_V2:'mob_rail_listing_v2',
  MMT_RAIL_QUOTA_SELECTION: 'mob_rail_quota_selection_',
  MMT_RAIL_LISTING_NO_TRAINS_AVAILABLE: 'mmt_rail_listing_No_Trains_Available',
  MMT_RAIL_AVAILABILITY_CHECK: 'mmt_rail_availability_check',
  MMT_RAIL_AVAILABILITY_CHECK_CLASS_NAME: 'mob_rail_availability_check_',
  MMT_RAIL_RN_LISTING_SORT: 'mob_rail_listing_sort_',
  MMT_RAIL_LISTING_SORTING_LOGIC: 'rails_listing_sorting_logic_',
  RAILS_NO_TRAINS_NO_OTHER_TRAINS: 'mob_rail_listing_v2_noTrainsFound_noTrainsOnOtherDates',
  RAILS_NO_TRAINS_OTHER_TRAINS_FOUND:'mob_rail_listing_v2_noTrainsFound_TrainsExistOnOtherDates',
  RAILS_LOAD_TIME_IMPROVEMENT:'rails_loadtime',
  MMT_RAIL_LISTING_BANNER_CLICKED:'rails_listing_banner_clicked',
  RAIL_LISTING_ERROR: 'TRAINS:Listing_',
  RAIL_LISTING_NULL_RESPONSE: 'TRAINS:Listing_response_json_is_null',
  RAIL_LISTING_SOMETHING_WRONG: 'TRAINS:Listing_something_went_wrong',
  RAIL_LISTING_R_SORT: 'Rsort',
  RAIL_LISTING_ROUTE_EXTENSION_YES: 're',
  RAIL_LISTING_ROUTE_EXTENSION_NO: 'nore',
  RAIL_LISTING_QUICK_FILTER_QUOTA_TAP :"rail_listing_quick_filter_quota",
  RAIL_LISTING_QUOTA_GENERAL :"rail_listing_quota_general",
  RAIL_LISTING_QUOTA_TATKAL :"rail_listing_quota_tatkal",
  RAIL_LISTING_QUOTA_LADIES :"rail_listing_quota_ladies",
  RAIL_LISTING_QUOTA_SR_CITIZEN :"rail_listing_quota_srcitizen",
  RAIL_LISTING_SEARCH_RETRY_EVENT_PREFIX: 'rail_error_retry_',
  RAIL_LISTING_ERROR_GO_BACK_EVENT: 'rail_error_goback',
  RAIL_LISTING_NEW_TBS_ERROR_ENABLED: 'ehl',
  RAIL_LISTING_NEW_TBS_ERROR_NOT_ENABLED: 'ehnl',
  RAIL_LISTING_CONFIRMED_OPTIONS_CLICKED: 'MMT_CNF',
  RAILS_AVAIL_DEPLETION_BS_SHOWN: 'rails_avail_depletion_listing_bottomsheet_shown',
  RAILS_DYNAMIC_PRICING_TOOLTIP_SHOWN: 'rails_dynamic_pricing_tooltip_shown',
  RAILS_DYNAMIC_PRICING: 'dp1',
  RAILS_NEXT_MWEB_TRUE: 'n_t',
  RAILS_NEXT_MWEB_FALSE: 'n_f',
};

const TRAVELLER_PAGE_EVENTS = {
  MOB_RAIL_TRAVELLERS_BOARDING_POINT_CHANGED: 'mob_rail_travellers_boarding_point_changed',
  MOB_RAIL_TRAVELLERS_CHANGE_BOARDING_POINT_LOAD: 'mob_rail_travellers_change_boarding_point_load',
  MOB_RAIL_TRAVELLERS_PAGE_TRAVELLERS_LIST_LOADED: 'mob_rail_travellers_page_travellers_list_loaded',
  MOB_RAIL_TRAVELLERS_TRAVELLERS_LIST_SELECT: 'mob_rail_travellers_travellers_list_select',
  MOB_RAIL_TRAVELLERS_ADD_TRAVELLER: 'mob_rail_travellers_add_traveller',
  MOB_RAIL_TRAVELLERS_ADD_TRAVELLER_SUCCESS: 'mob_rail_travellers_add_traveller_success',
  MOB_RAIL_TRAVELLERS_EDIT_TRAVELLER: 'mob_rail_travellers_edit_traveller',
  MOB_RAIL_TRAVELLERS_EDIT_TRAVELLER_SAVED: 'mob_rail_travellers_edit_traveller_saved',
  MOB_RAIL_TRAVELLERS_SENIOR_CITIZEN_CONCESSION_APPLIED: 'mob_rail_travellers_senior_citizen_concession_applied',
  MOB_RAIL_TRAVELLERS_SENIOR_CITIZEN_CONCESSION_NOT_APPLIED: 'mob_rail_travellers_senior_citizen_concession_not_applied',
  MOB_RAIL_TRAVELLERS_CHILD_INCLUDED: 'mob_rail_travellers_child included',
  MOB_RAIL_TRAVELLERS_CHILD_FULL_BERTH: 'mob_rail_travellers_child_full_berth',
  MOB_RAIL_TRAVELLERS_FOOD_VEG: 'mob_rail_travellers_food_veg',
  MOB_RAIL_TRAVELLERS_FOOD_NON_VEG: 'mob_rail_travellers_food_non_veg',
  MOB_RAIL_TRAVELLERS_CANCELLATION_POLICY_VIEW: 'mob_rail_travellers_cancellation_policy_view',
  MOB_RAIL_TRAVELLERS_SAME_COACH_SELECTED: 'mob_rail_travellers_same_coach_selected',
  MOB_RAIL_TRAVELLERS_LOWER_BERTH_SELECTED: 'mob_rail_travellers_lower_berth_selected',
  MOB_RAIL_TRAVELLERS_ADDPREF_ONE_LOWER_BERTH: 'mob_rail_travellers_addpref_one_lower_berth',
  MOB_RAIL_TRAVELLERS_ADDPREF_TWO_LOWER_BERTH: 'mob_rail_travellers_addpref_two_lower_berth',
  MOB_RAIL_TRAVELLERS_ADD_INSURANCE: 'mob_rail_travellers_add_insurance',
  MOB_RAIL_TRAVELLERS_USERID_CHANGE: 'mob_rail_travellers_userid_change',
  MOB_RAIL_TRAVELLERS_REQUEST_PASSWORD: 'mob_rail_travellers_request_password',
  MOB_RAIL_TRAVELLERS_REQUEST_PASSWORD_SUCCESS: 'mob_rail_travellers_request_password_success',
  MOB_RAIL_TRAVELLERS_REQUEST_PASSWORD_ERROR: 'mob_rail_travellers_request_password_error',
  MOB_RAIL_TRAVELLERS_CONTINUE: 'mob_rail_travellers_continue',
  MOB_RAIL_TRAVELLERS_ROUTE_EXTENSION_GO_BACK: 'mob_rail_travellers_confirmedoption_wl_GoBack',
  MOB_RAIL_TRAVELLERS_ROUTE_EXTENSION_CONTINUE: 'mob_rail_travellers_confirmedoption_wl_Continue',
  MOB_RAIL_TRAVELLERS_ADDITONAL_PREF_EXPAND: 'mob_rail_travellers_additonal_pref_expand',
  MOB_RAIL_TRAVELLERS_ADDITONAL_PREF_COLLAPSE: 'mob_rail_travellers_additonal_pref_collapse',
  MOB_RAIL_TRAVELLERS_ADDPREF_CONFIRMED_BERTHS: 'mob_rail_travellers_addpref_confirmed_berths',
  RAIL_TRAVELLER_PAGE_BACK_BUTTON_RESISTANCE_BOTTOMSHEET_TRACKER_GOBACK: 'rail_travelers_back_resistance_goback',
  RAIL_TRAVELLER_PAGE_BACK_BUTTON_RESISTANCE_BOTTOMSHEET_TRACKER_CONTINUE: 'rail_travelers_back_resistance_continue',
  RAILS_FC_TG_TOGETHER:'rails_TG_FC_together',
  RAILS_TRAVELLERS_TG:'rails_travellers_TG',
  RAILS_TRAVELLERS_FC:'rails_travellers_FC',
  RAILS_TRAVELLERS_SWITCH_TO:'rails_travellers_switchto',
  RAILS_TRAVELLERS_TG_PROMPT:'rails_tg_fc_together_tgprompt',
  RAILS_TRAVELLERS_FC_PROMPT:'rails_tg_fc_together_fcprompt',
  RAILS_TRAVELLERS_OLD_TG:'rails_travelers_TG_old',
  RAILS_TRAVELLERS_BNPP_ONPAGE: 'rails_bnpp_onpage',
  RAILS_TRAVELLERS_BNPP_BOTTOM_SHEET:'rails_bnpp_bottomsheet',
  RAILS_TRAVELLERS_BNPP_ARROW:'rails_bnpp_arrow',
  RAILS_TRAVELLERS_BNPP_TNC:'rails_bnpp_tnc_clicked',
  RAILS_TRAVELLERS_BNPP:'rails_bnpp',
  RAILS_TRAVELLERS_FC_WITH_BNPP: 'fcbnpp',
  RAILS_TARVELLERS_TG_ADDEED: 'tg_added',
  RAILS_TARVELLERS_TGP_ADDEED: 'tgp_added',
  RAILS_TARVELLERS_TG_REMOVED: 'tg_removed',
  RAILS_TARVELLERS_TGP_REMOVED: 'tgp_removed',
  RAILS_TARVELLERS_TGP_INFO_CLICK: 'rac_premium_info',
  RAILS_LONGNAME_ERROR: 'rails_longname_error',
  RAILS_BNPP_INFO_ICON_PARTIAL_CLICK: 'rails_partial_i',
  RAILS_BNPP_INFO_ICON_FULL_CLICK: 'rails_full_i',
  RAILS_BNPP_TOOLTIP_VISIBLE: 'sft',
  RAILS_BNPP_TOOLTIP_HIDDEN: 'sff',
  RAILS_TGP4_TG_ADDED: 'rails_tgp4_tgadded',
  RAILS_TGP4_TG_REMOVED: 'rails_tgp4_tgremoved',
  RAILS_TGP4_TGP_ADDED  : 'rails_tgp4_tgpadded',
  RAILS_TGP4_TGP_REMOVED  : 'rails_tgp4_tgpremoved',
  RAILS_TGP4_FC_ADDED : 'rails_tgp4_fcadded',
  RAILS_TGP4_FC_REMOVED : 'rails_tgp4_fcremoved',
  RAILS_AVAIL_ALERT_SHOWN: 'avail_alert_shown_',
  RAILS_AVAIL_ALERT_NOT_SHOWN: 'avail_alert_not_shown',
  RAILS_AVAIL_ALERT_SUBSCRIBED: 'avail_alert_subscribed',
  RAILS_AVAIL_ALERT_UNSUBSCRIBED: 'avail_alert_unsubscribed',
  RAILS_AVAIL_ALERT_BS_SHOWN: 'avail_alert_bs_shown',
  RAILS_TRAVELER_RE_BOTTOMSHEET_VARIANT_1: 'ct_bs_1',
  RAILS_TRAVELER_RE_BOTTOMSHEET_VARIANT_2: 'ct_bs_2',
  RAILS_AVAIL_DEPLETION_V1: 'sa1',
  RAILS_AVAIL_DEPLETION_V2: 'sa2',
  RAILS_AVAIL_DEPLETION_BS_SHOWN: 'rails_avail_depletion_traveller_bottomsheet_shown',
  RAILS_AVAIL_DEPLETION_SELLOUT: 'rails_avail_depletion_sellout_in',
  RAILS_TRAVELLER_PAGE_BACK_PRESS: 'mob_rail_traveller_header_back',
  RAILS_DYNAMIC_TRAIN_PERSAUSION: 'dtp',
  RAILS_FC_PREMIUM_EVENT: 'fc',
  RAILS_TRAVELLER_IRCTC_BOTTOMSHEET_NOTSHOWN: 'une_0',
  RAILS_TRAVELLER_IRCTC_BOTTOMSHEET_SHOWN: 'une_1',
  RAILS_TRAVELLER_COUPON_EXPERIMENT_VARIANT_ZERO: 'cou0',
  RAILS_TRAVELLER_COUPON_EXPERIMENT_VARIANT_ONE: 'cou1',
  RAILS_TRAVELLER_COUPON_EXPERIMENT_VARIANT_TWO: 'cou2',
  RAILS_TRAVELLER_COUPON_EXPERIMENT_VARIANT_THREE: 'cou3',
  RAILS_TRAVELLER_COUPON_EXPERIMENT_VARIANT_FOUR: 'cou4',
  RAILS_TRAVELLER_COUPON_EXPERIMENT_VARIANT_FIVE: 'cou5',
  RAILS_TRAVELLER_BOT_ICON_CLICKED: 'mob_rail_traveller_travelplex_icon_clicked',
  RAILS_TRAVELLER_TRAVELPLEX_LOADED: 'mob_rail_traveller_travelplex_loaded',
  RAILS_TRAVELLER_TRAVELPLEX_BOT_NOT_SHOWN: 'a_b0',
  RAILS_TRAVELLER_TRAVELPLEX_BOT_SHOWN: 'a_b1',
};
const THANK_YOU_PAGE_EVENTS = {
  MMT_RAILS_RN_ANDROID_THANK_YOU_SUCCESS: 'mmt_rails_RN_Android_Thank_You_Success',
  MMT_RAILS_RN_ANDROID_THANK_YOU_FAILURE: 'mmt_rails_RN_Android_Thank_You_Failure',
  RAILS_BNPP:'rails_bnpp',
};

const USER_FLOW_EVENTS = {
  mob_rail_listing_irctc_userid_popup_RN: 'mob_rail_listing_irctc_userid_popup_RN',
  mob_rail_listing_irctc_userid_popup_RN_enter_username: 'mob_rail_listing_irctc_userid_popup_RN_enter_username',
  mob_rail_travellers_irctc_userid_popup_RN_get_username:
    'mob_rail_travellers_irctc_userid_popup_RN_get_username',
  mob_rail_listing_irctc_userid_popup_RN_back_clicked: 'mob_rail_listing_irctc_userid_popup_RN_back_clicked',
  mob_rail_listing_irctc_userid_popup_RN_hard_back: 'mob_rail_listing_irctc_userid_popup_RN_hard_back',
  mob_rail_listing_irctc_userid_verify_username: 'mob_rail_listing_irctc_userid_verify_username',
  mob_rail_listing_irctc_userid_verify_username_dismiss_clicked: 'mob_rail_listing_irctc_userid_verify_username_dismiss_clicked',
  mob_rail_listing_irctc_userid_verify_username_hard_back: 'mob_rail_listing_irctc_userid_verify_username_hard_back',
  mob_rail_listing_irctc_userid_verified: 'mob_rail_listing_irctc_userid_verified',
  mob_rail_listing_irctc_userid_verified_change_clicked: 'mob_rail_listing_irctc_userid_verified_change_clicked',
  mob_rail_listing_irctc_userid_verified_forgot_password_clicked: 'mob_rail_listing_irctc_userid_verified_forgot_password_clicked',
  mob_rail_listing_irctc_userid_verified_continue_clicked: 'mob_rail_listing_irctc_userid_verified_continue_clicked',
  mob_rail_listing_irctc_userid_verified_dismiss_clicked: 'mob_rail_listing_irctc_userid_verified_dismiss_clicked',
  mob_rail_listing_irctc_userid_verified_forgot_hard_back: 'mob_rail_listing_irctc_userid_verified_forgot_hard_back',
  mob_rail_listing_irctc_forgot_username: 'mob_rail_listing_irctc_forgot_username',
  mob_rail_travellers_irctc_forgot_username_get_username_clicked:
    'mob_rail_travellers_irctc_forgot_username_get_username_clicked',
  mob_rail_listing_irctc_forgot_username_get_dismiss_clicked: 'mob_rail_listing_irctc_forgot_username_get_dismiss_clicked',
  mob_rail_listing_irctc_forgot_username_hard_back: 'mob_rail_listing_irctc_forgot_username_hard_back',
  mob_rail_listing_irctc_username_sent: 'mob_rail_listing_irctc_username_sent',
  mob_rail_listing_irctc_username_sent_verify_username_clicked: 'mob_rail_listing_irctc_username_sent_verify_username_clicked',
  mob_rail_listing_irctc_username_sent_resend_username_clicked: 'mob_rail_listing_irctc_username_sent_resend_username_clicked',
  mob_rail_listing_irctc_username_sent_create_new_account_clicked: 'mob_rail_listing_irctc_username_sent_create_new_account_clicked',
  mob_rail_listing_irctc_username_sent_dismiss_clicked: 'mob_rail_listing_irctc_username_sent_dismiss_clicked',
  mob_rail_listing_irctc_username_sent_hard_back: 'mob_rail_listing_irctc_username_sent_hard_back',
  mob_rail_listing_irctc_forgot_password: 'mob_rail_listing_irctc_forgot_password',
  mob_rail_listing_irctc_forgot_password_change_clicked: 'mob_rail_listing_irctc_forgot_password_change_clicked',
  mob_rail_listing_irctc_forgot_password_request_clicked:
    'mob_rail_listing_irctc_forgot_password_request_clicked',
  mob_rail_listing_irctc_forgot_password_dismiss_clicked:
    'mob_rail_listing_irctc_forgot_password_dismiss_clicked',
  mob_rail_listing_irctc_forgot_password_hard_back:
    'mob_rail_listing_irctc_forgot_password_hard_back',
  mob_rail_travellers_change_IRCTC_username: 'mob_rail_travellers_change_IRCTC_username',
  mob_rail_travellers_irctc_userid_popup_RN_create_account:
    'mob_rail_travellers_irctc_userid_popup_RN_create_account',
  mob_rail_travellers_get_new_irctc_password: 'mob_rail_travellers_get_new_irctc_password',
  MOB_RAIL_TRAVELLERS_AADHAR_ERRORS: 'dweb_rail_traveller_aadhar_errors',
  MOB_RAIL_TRAVELLERS_IRCTC_USERNAME_CHECK: 'mob_rail_travellers_irctc_username_check',
  MOB_RAIL_TRAVELLERS_IRCTC_USERNAME_CLOSE: 'mob_rail_travellers_irctc_username_close',
  MOB_RAIL_TRAVELLERS_IRCTC_USERNAME_CHECKBOX: 'mob_rail_travellers_irctc_username_checkbox',
  MOB_RAIL_TRAVELLERS_IRCTC_USERNAME_CROSS: 'mob_rail_travellers_irctc_username_cross',
  MOB_RAIL_TRAVELLERS_LINK_AADHAR: 'dweb_rail_travellers_link_aadhar',
  MOB_RAIL_TRAVELLERS_IRCTC_USERNAME_DONE: 'mob_rail_travellers_irctc_username_done',
  MOB_RAIL_TRAVELLERS_IRCTC_WHY_REQUIRED: 'mob_rail_travellers_irctc_why_required',
  MOB_RAIL_TRAVELLERS_IRCTC_CREATE_NOW: 'mob_rail_travellers_irctc_create_now',
  MOB_RAIL_TRAVELLERS_BS_LINK_AADHAR: 'mob_rail_travellers_bs_link_aadhar',
  MOB_RAIL_TRAVELLERS_AADHAR_BS_LOADED: 'mob_rail_travellers_aadhar_bs_loaded',
  mob_rail_travellers_irctc_userid_verify_username_verify_clicked: 'mob_rail_travellers_irctc_userid_verify_username_verify_clicked',
};

const USER_FLOW_EVENTS_V2 = {
  mob_rail_listing_irctc_userid_verify_username: 'mob_rail_listing_irctc_userid_verify_username',
  mob_rail_travellers_irctc_userid_verify_username_verify_clicked:
    ' mob_rail_travellers_irctc_userid_verify_username_verify_clicked',
  mob_rail_listing_irctc_userid_verify_username_dismiss_clicked: 'mob_rail_listing_irctc_userid_verify_username_dismiss_clicked',
  mob_rail_listing_irctc_userid_verify_username_get_username_clicked: 'mob_rail_listing_irctc_userid_verify_username_get_username_clicked',
  mob_rail_listing_irctc_userid_verify_username_create_account_clicked: 'mob_rail_listing_irctc_userid_verify_username_create_account_clicked'
};


const USER_VALIDATION_EVENTS = {
  MOB_RAIL_LISTING_IRCTC_USERID_POPUP_RN: 'mob_rail_listing_irctc_userid_popup_RN',
  MOB_RAIL_LISTING_IRCTC_USERID_CONTINUE_RN: 'mob_rail_listing_irctc_userid_continue_RN',
  MOB_RAIL_LISTING_FORGOT_USER_ID_RN: 'mob_rail_listing_forgot_user_ID_RN',
  MOB_RAIL_LISTING_IRCTC_USERID_CREATE_IRCTC_ACCOUNT_RN: 'mob_rail_listing_irctc_userid_create_irctc_account_RN',
  MOB_RAIL_LISTING_FORGOT_PASSWORD_BACK: 'mob_rail_listing_forgot_password_back',
  MOB_RAIL_LISTING_ID_VALIDATION_SUCCESS_RN: 'mob_rail_listing_id_validation_success_RN',
  MOB_RAIL_LISTING_FORGOT_PASSWORD_RN: 'mob_rail_listing_forgot_password_RN',
  MOB_RAIL_LISTING_REMEMBER_PASSWORD_RN: 'mob_rail_listing_remember_password_RN',
  MOB_RAIL_LISTING_ID_VALIDATION_FAILURE_RN: 'mob_rail_listing_id_validation_failure_RN',
  MOB_RAIL_LISTING_ID_FORGOT_USER_ID_RN: 'mob_rail_listing_id_forgot_user_ID_RN',
  MOB_RAIL_LISTING_ID_VALIDATION_FAILURE_CHANGE_RN: 'mob_rail_listing_id_validation_failure_change_RN',
  MOB_RAIL_LISTING_ID_FORGOT_USERID_RN: 'mob_rail_listing_id_forgot_userid_RN',
  MOB_RAIL_LISTING_ID_FORGOT_USERID_CONTINUE: 'mob_rail_listing_id_forgot_userid_continue',
  MOB_RAIL_LISTING_ID_FORGOT_USERID_CREATE_NEW_IRCTC_ACCOUNT: 'mob_rail_listing_id_forgot_userid_create_new_irctc_account',
  MOB_RAIL_LISTING_USER_ID_SENT: 'mob_rail_listing_user_id_sent',
  MOB_RAIL_LISTING_RETRIEVE_USER_ID_ERROR: 'mob_rail_listing_retrieve_user_id_error',
  MOB_RAIL_LISTING_FORGOT_PASSWORD: 'mob_rail_listing_forgot_password',
  MOB_RAIL_LISTING_FORGOT_PASSWORD_CONTINUE: 'mob_rail_listing_forgot_password_continue',
  MOB_RAIL_LISTING_PASSWORD_SENT: 'mob_rail_listing_password_sent',
  MOB_RAIL_LISTING_RETRIEVE_PASSWORD_ERROR: 'mob_rail_listing_retrieve_password_error',
  MOB_RAIL_LISTING_USERID_VALIDATION_SUCCESS: 'mob_rail_listing_userid_validation_success',
  MOB_RAIL_LISTING_ID_VALIDATION_FAILURE: 'mob_rail_listing_id_validation_failure',
  MMT_RAIL_POST_PAYMENT_FORGOT_PASSWORD: 'mmt_rail_post_payment_forgot_password',
  MMT_RAIL_POST_PAYMENT_FORGOT_PASSWORD_CONTINUE: 'mmt_rail_post_payment_forgot_password_continue',
  MMT_RAIL_POST_PAYMENT_RETRIEVE_PASSWORD_SUCCESS: 'mmt_rail_post_payment_retrieve_password_success',
  MMT_RAIL_POST_PAYMENT_RETRIEVE_PASSWORD_ERROR: 'mmt_rail_post_payment_retrieve_password_error',
  MMT_RAIL_POST_PAYMENT_FORGOT_PASSWORD_ATTEMPT_LIMIT_EXCEEDED: 'mmt_rail_post_payment_forgot_password_attempt_limit_exceeded',
  MMT_RAIL_POST_PAYMENT_FORGOT_PASSWORD_DISMISS: 'mmt_rail_post_payment_forgot_password_dismiss'
};

const REVIEW_PAGE_EVENTS = {
  MOB_RAIL_REVIEW_RN: 'mob_rail_review_RN',
  RAIL_REVIEW_PAGE_BACK_BUTTON_RESISTANCE_BOTTOMSHEET_TRACKER_GOBACK: 'rail_review_back_resistance_goback',
  RAIL_REVIEW_PAGE_BACK_BUTTON_RESISTANCE_BOTTOMSHEET_TRACKER_CONTINUE: 'rail_review_back_resistance_continue',
  IRCTC_PASS_BOTTOMSHEET_BS_LOAD: 'mob_rail_review_bs_load',
  IRCTC_PASS_BOTTOMSHEET_PROCEED_TO_PAYMENT_CLICK: 'mob_rail_review_bs_proceed',
  IRCTC_PASS_BOTTOMSHEET_CHECKBOX_CLICK: 'mob_rail_review_bs_checkbox',
  IRCTC_PASS_BOTTOMSHEET_RETRIEVE_PASS_CLICK: 'mob_rail_review_get_password',
  IRCTC_PASS_BOTTOMSHEET_CREATE_ACCOUNT_CLICK: 'mob_rail_review_bs_create_account',
  IRCTC_PASS_BOTTOMSHEET_EDIT_USERNAME_CLICK: 'mob_rail_review_bs_edit_username',
  IRCTC_PASS_BOTTOMSHEET_CROSS_CLICK: 'mob_rail_review_bs_cross',
  IRCTC_PASS_BOTTOMSHEET_EVENT: 'ir',
};

export const RAILS_POST_PAYMENT_FAILURE = {
  MOB_RAIL_FAILURE_CLOSED_SCREEN: 'mob_rail_failure_closed_screen',
  MOB_RAIL_FAILURE_WALLET_SELECTED: 'mob_rail_failure_wallet_selected',
  MOB_RAIL_FAILURE_BANK_SELECTED: 'mob_rail_failure_bank_selected',
  MOB_RAIL_FAILURE_CONTINUE_CLICKED: 'mob_rail_failure_continue_clicked',
};

const FC_TG_INTERVENTION = {
  FC: 'FC_',
  TG: 'TG_',
  TGP: 'TGP_',
  LANDING: 'landing_',
  LISTING: 'listing_',
  TRAVELER: 'traveler_',
  PROMPT: 'prompt_',
  PRE_SELECTED: 'pre',
  PRE_UN_SELECTED: 'notpre',
  SELECTED: 'select',
  UN_SELECTED: 'unselect',
  TGP_SELECTED: 'TGP_select',
  TGP_UNSELECTED: 'TGP_unselect',
}

export const IRCTC = {
  MOB_RAILS_IRCTC_PAGE: 'mob_rail_irctc_password_after_payments',
  IRCTC_LOAD_SUCCESS:'TRAINS:IRCTC_LOAD_retry_success',
  IRCTC_LOAD_FAILED:'TRAINS:IRCTC_LOAD_retry_failed',
  IRCTC_LOAD_ERROR:'TRAINS:IRCTC_LOAD_ERROR',
};

export const FCTG_TOGETHER = 'TG-FC-';

const RAILS_TG_ELIGIBILITY_CHANGE = {
  RAILS_TG_ELIGIBILITY_CHANGE: 'rails_tg_eligibility_change',
  PAGE_NAME: 'mob_rail_review',
};

const RAIL_EVENTS = {
  LANDING: LANDING_PAGE_EVENTS,
  LISTING: LISTING_PAGE_EVENTS,
  TRAVELLER: TRAVELLER_PAGE_EVENTS,
  THANK_YOU: THANK_YOU_PAGE_EVENTS,
  USER: USER_VALIDATION_EVENTS,
  REVIEW: REVIEW_PAGE_EVENTS,
  USERFLOW: USER_FLOW_EVENTS,
  USER_FLOW_V2: USER_FLOW_EVENTS_V2,
  FCTG: FC_TG_INTERVENTION,
  IRCTC: IRCTC,
  RAILS_TG_ELIGIBILITY_CHANGE,
};

export default RAIL_EVENTS;
